import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface OrnamentProps {
    className?: string
}

// A single marigold bloom. Takes its petal colour from the text colour.
export const Marigold: FC<OrnamentProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 20 20' aria-hidden='true' className={cn('size-5 shrink-0', className)}>
            <g fill='currentColor'>
                <circle cx='14.6' cy='10' r='3' />
                <circle cx='13.25' cy='13.25' r='3' />
                <circle cx='10' cy='14.6' r='3' />
                <circle cx='6.75' cy='13.25' r='3' />
                <circle cx='5.4' cy='10' r='3' />
                <circle cx='6.75' cy='6.75' r='3' />
                <circle cx='10' cy='5.4' r='3' />
                <circle cx='13.25' cy='6.75' r='3' />
            </g>
            <circle cx='10' cy='10' r='2.6' fill='#c26a06' />
        </svg>
    )
}

// A thin divider with a marigold at its centre. Takes its line colour from the text colour.
export const Ornament: FC<OrnamentProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 160 16' fill='none' aria-hidden='true' className={cn('h-4 w-40', className)}>
            <path d='M0 8h62M98 8h62' stroke='currentColor' strokeWidth='1' />
            <path d='M66 8l4-4 4 4-4 4z' stroke='currentColor' strokeWidth='1' />
            <path d='M86 8l4-4 4 4-4 4z' stroke='currentColor' strokeWidth='1' />
            <g className='fill-marigold'>
                <circle cx='83' cy='8' r='1.8' />
                <circle cx='82.12' cy='10.12' r='1.8' />
                <circle cx='80' cy='11' r='1.8' />
                <circle cx='77.88' cy='10.12' r='1.8' />
                <circle cx='77' cy='8' r='1.8' />
                <circle cx='77.88' cy='5.88' r='1.8' />
                <circle cx='80' cy='5' r='1.8' />
                <circle cx='82.12' cy='5.88' r='1.8' />
            </g>
            <circle cx='80' cy='8' r='1.4' fill='currentColor' />
        </svg>
    )
}
